/* @ngInject */
const resource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.owner}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'post': {
      method: 'POST',
    },
  }
  )
}

export default resource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/resource.service.js